import React, { Component } from "react";
import { VzPageContainer } from "../../layouts/VzPageContainer";
export default class About extends Component {
  render() {
    return (
      <div>
        <VzPageContainer title="About">
        </VzPageContainer>
      </div>
    );
  }
}
